import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import Typography from "material-ui/Typography";
import { MenuItem } from "material-ui/Menu";
import { FormControl } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import { CircularProgress } from "material-ui/Progress";
import Button from "material-ui/Button";
import DoneIcon from "material-ui-icons/Done";
import classNames from "classnames";
import Videos from "./videos/Videos";
import { required } from "../../utils/form/formValidation";
import styles from "./FormPlaylist.scss";

const FormPlaylist = ({
  title: formTitle,
  playlists,
  handleOnSubmit,
  requesting,
  preventSubmit,
  selectedPlaylistId,
  isMobile,
}) => {
  let form;

  return (
    <div className={classNames({ mt4: true, [styles.container]: true })}>
      <Typography type="display1" align="center" className="mb3">
        {formTitle}
      </Typography>
      <form
        autoComplete="off"
        className={styles.form}
        onSubmit={handleOnSubmit}
      >
        <div className="mb2">
          <FormControl className={styles.field} fullWidth>
            <InputLabel htmlFor="model">Modèle</InputLabel>
            <Field id="model" name="model" component={Select}>
              <MenuItem value="Aucun">Aucun</MenuItem>
              {playlists.map(({ title, id }) => (
                <MenuItem value={id} key={id}>
                  {title}
                </MenuItem>
              ))}
            </Field>
          </FormControl>
        </div>
        <div className="mb2">
          <Field
            name="title"
            placeholder="Titre *"
            label="Titre *"
            component={TextField}
            validate={[required]}
            fullWidth
          />
        </div>
        <div className="mb2">
          <Field
            name="description"
            placeholder="Description *"
            label="Description *"
            component={TextField}
            validate={[required]}
            fullWidth
          />
        </div>
        <Button
          variant={isMobile ? "fab" : "raised"}
          type={requesting || preventSubmit ? "" : "submit"}
          color="primary"
          aria-label="Enregistrer"
          className={isMobile ? styles.fab : styles.textbutton}
        >
          {requesting ? (
            <CircularProgress className={styles.requesting} />
          ) : isMobile ? (
            <DoneIcon />
          ) : (
            "Valider"
          )}
        </Button>
      </form>
      <Videos playlistId={selectedPlaylistId} />
    </div>
  );
};

FormPlaylist.propTypes = {
  title: PropTypes.string.isRequired,
  playlists: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  requesting: PropTypes.bool,
  handleOnSubmit: PropTypes.func.isRequired,
  selectedPlaylistId: PropTypes.string,
  preventSubmit: PropTypes.bool,
  isMobile: PropTypes.bool,
};

FormPlaylist.defaultProps = {
  requesting: false,
  selectedPlaylistId: undefined,
  preventSubmit: false,
};

export default FormPlaylist;



// WEBPACK FOOTER //
// ./src/pages/playlists/form/FormPlaylist.jsx